"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonasPropertyCard = void 0;
var react_1 = __importStar(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var SearchHighlight_1 = require("../../shared/components/SearchHighlight");
var PersonasUseCaseCallout_1 = require("./PersonasUseCaseCallout");
/**
 * Single persona card in the right panel. Owns the local pill ref used
 * to anchor the use-case callout but delegates open/close state to the
 * parent so only one callout is open at a time across the panel.
 */
exports.PersonasPropertyCard = function (_a) {
    var property = _a.property, isSelected = _a.isSelected, isChanged = _a.isChanged, searchMatcher = _a.searchMatcher, openUseCasesPropertyId = _a.openUseCasesPropertyId, onToggleSelection = _a.onToggleSelection, onToggleUseCases = _a.onToggleUseCases, onDismissUseCases = _a.onDismissUseCases, onOpenUseCase = _a.onOpenUseCase;
    var pillRef = react_1.useRef(null);
    var useCaseCount = property.useCases.length;
    var isCalloutOpen = openUseCasesPropertyId === property.id;
    var className = 'ws-personas-property-card' +
        (isSelected ? ' is-selected' : '') +
        (isChanged ? ' is-changed' : '');
    return (react_1.default.createElement("div", { key: property.id, className: className, role: "button", tabIndex: 0, "aria-pressed": isSelected, onClick: function (event) {
            // Ignore clicks coming from the use-case pill / callout so they
            // can do their own thing without also toggling selection.
            var target = event.target;
            if (target.closest('.ws-personas-property-aside')) {
                return;
            }
            onToggleSelection(property.id);
        }, onKeyDown: function (event) {
            if (event.key === ' ' || event.key === 'Enter') {
                event.preventDefault();
                onToggleSelection(property.id);
            }
        } },
        react_1.default.createElement(office_ui_fabric_react_1.Checkbox, { checked: isSelected, onChange: function () { return onToggleSelection(property.id); }, ariaLabel: "Select " + property.name }),
        react_1.default.createElement("div", { className: "ws-personas-property-main" },
            react_1.default.createElement("span", { className: "ws-personas-property-name" },
                react_1.default.createElement(SearchHighlight_1.HighlightedText, { value: property.name, matcher: searchMatcher }))),
        react_1.default.createElement("div", { className: "ws-personas-property-aside" },
            react_1.default.createElement("button", { type: "button", className: "ws-personas-usecase-pill", ref: pillRef, disabled: useCaseCount === 0, title: useCaseCount === 0
                    ? 'Not targeted by any use case'
                    : "Targeted by " + useCaseCount + " use case" + (useCaseCount === 1 ? '' : 's'), onClick: function () {
                    if (useCaseCount === 0) {
                        return;
                    }
                    onToggleUseCases(property.id);
                } },
                react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: "ReminderGroup" }),
                react_1.default.createElement("span", null,
                    "Targeted by ",
                    useCaseCount,
                    " use case",
                    useCaseCount === 1 ? '' : 's'))),
        isCalloutOpen && (react_1.default.createElement(PersonasUseCaseCallout_1.PersonasUseCaseCallout, { property: property, target: pillRef.current, onDismiss: onDismissUseCases, onOpenUseCase: onOpenUseCase }))));
};
